import {
  Dialog,
  DialogTitle,
  DialogContent,
  TextField,
  DialogActions,
  Button,
  Rating,
  Switch,
} from '@mui/material'
import { observer } from 'mobx-react-lite'
import React from 'react'
import { toast } from 'react-toastify'
import OrderItem from '../../components/Order/OrderItem'
import RootStore from '../../store/RootStore'
import { toastConfig } from '../../helpers/toastConfig'
import './styles/Orders.scss'
import StarIcon from '@mui/icons-material/Star'
import StarBorderIcon from '@mui/icons-material/StarBorder'
import EditOrder from '../../components/modals/EditOrder'
import { Order } from '../../types/models/Order'
import { IoVolumeHigh, IoVolumeMute } from 'react-icons/io5'
import CompleteOrder from '../../components/modals/CompleteOrder'
import AddKeyToUser from '../../components/modals/AddKeyToUser'

const alarm = require('../../static/audio/alarm.wav')

const margin = 'dense'
const variant = 'standard'

type Props = {
  lite?: boolean
}

const Orders = observer((props: Props) => {
  const { lite } = props
  const { isFilterCurrentPath, currentPath, audioOn } = RootStore.userAction
  const orders = RootStore.userAction.orders
  const defaultLoaction = RootStore.settingsStore.location

  const [orderId, setOrderId] = React.useState(0)
  const [feedback, setFeedback] = React.useState('')
  const [rating, setRating] = React.useState(5)

  React.useEffect(() => {
    fetchData()
    const timer = setInterval(fetchData, 3000)
    return () => {
      clearInterval(timer)
    }
  }, [])

  const fetchData = async () => {
    await RootStore.userAction.getNewOrders()
  }

  if (!orders)
    return (
      <div className="Home-content">
        <p>Загрузка...</p>
      </div>
    )

  const hundleAccept = (order: Order) => {
    if (order) RootStore.modalsUi.hundleEditOrder(true, order)
  }

  const hundleComplete = (order: Order) => {
    if (order) RootStore.modalsUi.hundleCompleteOrder(true, order)
  }

  const hundleEnd = (id: number) => {
    setOrderId(id)
  }

  const hundleClose = async () => {
    setFeedback('')
    setRating(5)
    setOrderId(0)
  }

  const hundleChange = async () => {
    const toastId = toast.loading('Обработка...', toastConfig)

    try {
      await RootStore.userAction.endOrder(orderId, { feedback, rating })
      toast.update(toastId, {
        render: 'Успешно',
        type: 'success',
        isLoading: false,
        ...toastConfig,
      })
      setOrderId(0)
      fetchData()
    } catch (error: any) {
      const data = error.response?.data
      toast.update(toastId, {
        render: data?.message ?? 'Произошла ошибка',
        type: 'error',
        isLoading: false,
        ...toastConfig,
      })
    }
  }

  const order = orders.find((order) => order.id === orderId)

  return (
    <div className="order">
      {lite ? (
        <>
          <p className="order-helperText">По текущему расположению</p>
          <Switch
            checked={isFilterCurrentPath}
            onChange={() => {
              RootStore.userAction.setFilterCurrentPath(!isFilterCurrentPath)
            }}
          />
        </>
      ) : (
        <>
          <div className="order-volume">
            {audioOn ? (
              <IoVolumeMute
                onClick={() => RootStore.userAction.setMuteAudio(false)}
                size={32}
              />
            ) : (
              <IoVolumeHigh
                onClick={() => RootStore.userAction.setMuteAudio(true)}
                size={32}
              />
            )}
          </div>
          {orders.find((order) => {
            return !order.takeTime
          }) ? (
            <audio loop src={alarm} muted={audioOn} autoPlay />
          ) : null}
        </>
      )}

      {orders.length ? (
        orders.map((order) => {
          if (isFilterCurrentPath && currentPath) {
            if (!order.locationPath?.includes(currentPath)) {
              return null
            }
          }
          if (
            defaultLoaction &&
            !order.locationPath?.includes(defaultLoaction.name)
          ) {
            return null
          }
          return (
            <OrderItem
              key={order.id}
              order={order}
              lite={lite}
              onAccepted={() => {
                hundleAccept(order)
              }}
              onCompleted={() => {
                hundleComplete(order)
              }}
              onEnd={() => {
                hundleEnd(order.id)
              }}
            />
          )
        })
      ) : (
        <p className="order-helperText">Нет заявок ✔</p>
      )}

      <Dialog open={!!orderId} onClose={hundleClose}>
        <DialogTitle>Оценка ...</DialogTitle>
        <div className="order-modals">
          <DialogContent>
            <TextField
              label="Отзыв (необязательно)"
              onChange={(event) => setFeedback(event.target.value)}
              multiline
              variant={variant}
              margin={margin}
              rows={3}
              fullWidth
            />
            <div className="order-modals-rating">
              <Rating
                defaultValue={5}
                max={10}
                precision={1}
                onChange={(event, newValue) => {
                  if (newValue) setRating(newValue)
                }}
                icon={<StarIcon fontSize="inherit" />}
                emptyIcon={<StarBorderIcon fontSize="inherit" />}
              />
              <div className="order-modals-rating-number">{rating} / 10</div>
            </div>
          </DialogContent>
          {order ? <OrderItem order={order} noAction /> : null}
        </div>

        <DialogActions>
          <Button onClick={hundleChange}>Оценить работу</Button>
          <Button onClick={hundleClose}>Отмена</Button>
        </DialogActions>
      </Dialog>
      <EditOrder />
      <CompleteOrder />
      <AddKeyToUser />
    </div>
  )
})

export default Orders
